import { parseUnits } from '@ethersproject/units'
import JSBI from 'jsbi'

import { ChainId } from '../sdk/chainId'

import { getChain } from './active'

/** Reserva nativa en unidades mínimas (wei) para la cadena dada. */
export function getNativeGasReserveRaw(chainId: ChainId): JSBI {
  const chain = getChain(chainId)
  return JSBI.BigInt(parseUnits(chain.nativeGasReserve, chain.nativeCurrency.decimals).toString())
}

/** Reserva nativa legible (p. ej. `0.01` CRE42) para mensajes de UI. */
export function getNativeGasReserveAmount(chainId: ChainId): string {
  return getChain(chainId).nativeGasReserve
}
